<script>
  import AtAGlance from './AtAGlance.svelte';
  import AtAGlancePrecinctsReporting from './AtAGlancePrecinctsReporting.svelte';
  /**
   *  @type {object}
   */
  export let races;

  // /**
  //  * A readable Svelte store of an individual Race.
  //  *
  //  *  @type {import('../types.d').RaceFeed}
  //  */
  // export let precincts;

  // /**
  //  * A readable Svelte store of an individual Race.
  //  *
  //  *  @type {import('../types.d').RaceFeed}
  //  */
  // export let gov;

  // /**
  //  * A readable Svelte store of an individual Race.
  //  *
  //  *  @type {import('../types.d').RaceFeed}
  //  */
  // export let ag;

  // /**
  //  * A readable Svelte store of an individual Race.
  //  *
  //  *  @type {import('../types.d').RaceFeed}
  //  */
  // export let mayor;

  // /**
  //  * A readable Svelte store of an individual Race.
  //  *
  //  *  @type {import('../types.d').RaceFeed}
  //  */
  // export let sheriff;

  /**
   * @type {Map<string, import('../types.d').Crosswalk>}
   */
  export let crosswalk;

  $: votesIn = races
    .map((r) => {
      r['store'].subscribe((value) => {
        return value.total_votes > 0;
      });
    })
    .every((el) => el === true);
</script>

<div class="aag-container">
  <p class="aag-title">Key races at a glance</p>
  <p class="aag-description"><span><span class="check">✓</span> Winner</span>  <span>* Incumbent</span></p>
  <div class="aag-races-container display-grid grid-cols-2 grid-gap-3 mb-3 mt-1">
    {#each races as race}
      {#if race.race != 'precincts'}
        <div class="race-container" id="aag-{race.id}">
          <AtAGlance name={race.race} race={race.store} {crosswalk} />
        </div>
      {/if}
    {/each}
  </div>
</div>
